export default () => ({
    forgot: {
        textAlign: 'right',
        marginBottom: 16,
    },
    signup: {
        marginTop: 16,
        '& *': {
            display: 'inline',
        },
    },
    error: {
        marginBottom: 8,
    },
});
